/**
 * The reference scheme defines the type of entity identifier being used with the Vista CDN.
 */
export var VistaReferenceScheme;
(function (VistaReferenceScheme) {
    /**
     * Use this reference scheme when you are using the primary key identifier from the Cinema database.
     *
     * For example: the `Film_strCode` from `tblFilm` in the Cinema DB.
     * @default
     */
    VistaReferenceScheme["Cinema"] = "Cinema";
    /**
     * Use this reference scheme when you are using the primary key identifier from the Head Office database (known as the HOPK).
     *
     * For example: the `HOPK` from `tblFilm` in the Cinema DB.
     */
    VistaReferenceScheme["HeadOffice"] = "HeadOffice";
    /**
     * Use this when you are using neither the Cinema nor Head Office identifiers, but rather another global identifier.
     *
     * For example: the `Film_strHOFilmCode` from `tblFilm` in the Cinema DB.
     */
    VistaReferenceScheme["Global"] = "Global";
})(VistaReferenceScheme || (VistaReferenceScheme = {}));
//# sourceMappingURL=reference-scheme.js.map